import React, { useEffect, useMemo, useState } from 'react';

import { FaRegCalendar } from 'react-icons/fa6';

import ModalAnalist from 'pages/NewRefuel/RefuelContainer/ModalAnalist';
import { BaseTerritoryData } from 'services/basesServices';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';
import { REFUEL_MESSAGES } from 'components/layout/Portal/MinhasSolicitacoes/constants';
import BaseSelected from '../../RefuelContainer/components/BaseSelected';

import routeInfoImg from '../../assets/routeInfo.svg';
import noRouteInfoImg from '../../assets/noRouteInfo.svg';

import routeInfoMobileImg from '../../assets/routeInfoMobileFull.svg';
import noRouteInfoMobileImg from '../../assets/noRouteInfoMobile.svg';

import { useNewRefuel } from '../../hooks/useNewRefuel';

import Calendar from './Calendar';

import {
  Container,
  SelectBasesWrap,
  ScheduleFormWrapper,
  BasesContainer,
  ScheduleFormHeader,
  ScheduleFormInfosWrapper,
  QuestionRefuel,
  QuestionComplement,
  CalendarWrapper,
  RouteInfoWrapper,
  RouteInfoImage,
  Divider,
  RefuelDateInformationWrapper,
  RefuelDataLabel,
  RefuelDataValue,
  ModalStyled,
  ContainerTextWrapper,
  LabelRefuelDescription,
} from './styles';

const ScheduleDate: React.FC = () => {
  const [selectDate, setSelectDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [baseTerritory, setBaseTerritory] = useState<BaseTerritoryData>(
    {} as BaseTerritoryData
  );
  const [isFixedRouteSelected, setIsFixedRouteSelected] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    selectedBases,
    selectedBase,
    refuelData,
    handleRefuelDate,
    stepError,
  } = useNewRefuel();

  const handleDateChange = (date: string, isFixedRoute: boolean): void => {
    if (selectedBase?.name) {
      handleRefuelDate(selectedBase?.name, date, isFixedRoute);
      setIsFixedRouteSelected(isFixedRoute);
    }
  };

  useEffect(() => {
    const idx = refuelData.findIndex(
      (item) => item.baseName === selectedBase?.name
    );

    if (idx !== -1) {
      setSelectDate(refuelData[idx].refuelDate);
    } else {
      setSelectDate('');
    }
  }, [refuelData, selectedBase]);

  useEffect(() => {
    const baseTerritoryResponse = selectedBases.find(
      (base) => base.name === selectedBase?.name
    );
    setBaseTerritory(baseTerritoryResponse?.baseTerritory as BaseTerritoryData);
  }, [selectedBase, selectedBases]);

  const { numberOfDaysToSuplay } = baseTerritory?.base || 0;

  const refuelDateSome = useMemo(() => {
    if (selectDate) {
      const selectDateMoment = moment(selectDate, 'YYYY-MM-DD');
      selectDateMoment.add(numberOfDaysToSuplay - 1, 'days');
      return selectDateMoment.format('DD/MM/YYYY');
    }
    return '';
  }, [selectDate, numberOfDaysToSuplay]);

  const refuelDateFormatted = useMemo(() => {
    if (selectDate) {
      return moment(selectDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
    return '';
  }, [selectDate]);

  return (
    <Container>
      <SelectBasesWrap>
        <BasesContainer>
          {!isMobile && selectedBases.length > 0 && (
            <>
              {selectedBases.map((base) => (
                <BaseSelected
                  isSelected={base.name === selectedBase?.name}
                  baseName={base.name}
                  nickName={base.nickname}
                  address={`${base.address}, ${base.number} - ${base.complement}`}
                  isComplete={base.dateValidate}
                  isError={stepError === 3 && !base?.dateValidate}
                />
              ))}
            </>
          )}
        </BasesContainer>
      </SelectBasesWrap>
      <ScheduleFormWrapper>
        <ScheduleFormHeader>
          <ScheduleFormInfosWrapper>
            <QuestionRefuel>
              Qual o melhor dia para o abastecimento?
            </QuestionRefuel>
            <QuestionComplement>
              Selecione aqui a melhor data para realizarmos a entrega do seu
              gás.
            </QuestionComplement>
          </ScheduleFormInfosWrapper>
        </ScheduleFormHeader>
        <CalendarWrapper>
          <Calendar
            initialSelectedDate={selectDate}
            handleDateChange={handleDateChange}
            clickAnalyst={() => setShowModal(true)}
            baseTerritory={baseTerritory}
          />
        </CalendarWrapper>
        <RouteInfoWrapper>
          {isMobile && (
            <RouteInfoImage
              src={
                isFixedRouteSelected ? routeInfoMobileImg : noRouteInfoMobileImg
              }
            />
          )}
          {!isMobile && (
            <RouteInfoImage
              src={isFixedRouteSelected ? routeInfoImg : noRouteInfoImg}
            />
          )}
        </RouteInfoWrapper>
        <Divider />
        {refuelDateFormatted && (
          <RefuelDateInformationWrapper
            isError={stepError === 3 && !selectDate}
          >
            <ContainerTextWrapper>
              <FaRegCalendar size={isMobile ? 18 : 24} color="#3d3d3d" />
              <RefuelDataLabel>
                {numberOfDaysToSuplay > 1
                  ? 'Previsão de entrega entre'
                  : 'Previsão de entrega'}
              </RefuelDataLabel>
              <RefuelDataValue>
                {numberOfDaysToSuplay > 1
                  ? `${refuelDateFormatted} a ${refuelDateSome}`
                  : refuelDateFormatted}
              </RefuelDataValue>
            </ContainerTextWrapper>
            {refuelDateFormatted && (
              <LabelRefuelDescription>
                <div
                  dangerouslySetInnerHTML={{
                    __html: REFUEL_MESSAGES.PREVIEW_DESCRIPTION,
                  }}
                />
              </LabelRefuelDescription>
            )}
          </RefuelDateInformationWrapper>
        )}
      </ScheduleFormWrapper>
      <ModalStyled
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered
      >
        <ModalAnalist closeModal={() => setShowModal(false)} />
      </ModalStyled>
    </Container>
  );
};

export default ScheduleDate;
